import Nav from "../components/Nav";
import Hero from "../components/Hero";
import EditorialMarquee from "../components/Marquee";
import Services from "../components/Services";
import Verticals from "../components/Verticals";
import Manifesto from "../components/Manifesto";
import Portfolio from "../components/Portfolio";
import Testimonials from "../components/Testimonials";
import Journal from "../components/Journal";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <Services />
      <Portfolio />
      <Verticals />
      <Manifesto />
      <EditorialMarquee speed={30} />
      <Testimonials />
      <Journal />
      <Contact />
      <Footer />
    </main>
  );
}
